var DEGREE = 180 / Math.PI;
var toDegree = function (radian) {
    return DEGREE * radian;
};
export default toDegree;
//# sourceMappingURL=to-degree.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/to-degree.js
// module id = 527
// module chunks = 3